class MECSingleEvent {
  constructor() {
    this.body = document.querySelector('body');
    this.mecContainer = document.querySelector('.mec-container');
    this.title = this.mecContainer.querySelector('.mec-single-title');

    this.analytics = {
      'event': 'eventRegistration',
      'eventName': this.title.innerHTML,
      'tickets': {},
    };

    const classes = document.querySelector('.single-mec-events');
    classes.classList.forEach(cl => {
      if (cl.indexOf('postid-') > -1) {
        this.eventId = cl.substring(7);
      }
    });

    this.addListener = true;
    this.timeConverted = false;
    this.init();
  }

  init() {
    if (document.querySelector('.mec-single-title').innerHTML === 'Corpse Plant Viewing') {
      const caption = document.createElement('div');
      caption.style = 'max-width: 370px';
      caption.innerHTML = `<i class="plant-bio__characteristic-caption">Corpse Plant blooming at Edmonton's Muttart Conservatory in 2015, as a representation of how the Arboretum’s Corpse Plant will look in full bloom.</i>`;
      document.querySelector('.mec-events-event-image').appendChild(caption);
    }

    // Add a hook for page changes
    this.onElementAddedToForm();

    // Fix cancel stuff at the top
    const cancel = document.querySelector('.mec-container > .warning-msg');
    if (cancel) {
      cancel.classList.add('mec-single__cancel');
    }

    this.body.classList.add('light-nav');
    const container = this.title.closest('.col-md-8');
    container.prepend(this.title);

    // Add Register banner
    const registerBanner = document.createElement('div');
    registerBanner.classList.add('mec-single__booking-banner');
    registerBanner.innerHTML = 'REGISTER';
    const referenceNode = document.querySelector('.mec-events-meta-group');
    if (referenceNode.children.length > 0) {
      referenceNode.parentNode.insertBefore(registerBanner, referenceNode);
    }

    // Remove registration button
    const registrationButton = document.querySelector('.mec-booking-button');
    if (registrationButton) {
      registrationButton.remove();
    }

    // Remove QR Code and add to calendar
    const qrCode = this.mecContainer.querySelector('.mec-qrcode-details');
    if (qrCode) {
      qrCode.remove();
    }

    const cal = this.mecContainer.querySelector('.mec-event-export-module');
    if (cal) {
      cal.remove();
    }

    // Make the cancel button more uniform to rest of site
    const cancelButton = document.querySelector('.mec-container>.warning-msg a');
    if (cancelButton) {
      cancelButton.classList.add('button');
      cancelButton.classList.add('button--default');
    }

    // Add date comma
    const date = document.querySelector('.mec-start-date-label');
    if (date) {
      const text = date.innerHTML;
      date.innerHTML = `${text.substring(0, text.length - 5)}, ${text.substring(text.length - 4)}`;
    }

    // Hide other tours
    const subjectMatters = document.querySelectorAll('.mec-single-event-category .mec-events-event-categories a');
    subjectMatters.forEach(subjectMatter => {
      if (subjectMatter.innerHTML.indexOf('Other Tours') > -1) {
        subjectMatter.parentElement.remove();
      }
    });

    // Map and location getting fitted into right places
    const locationContainer = document.querySelector('.mec-single-event-location');
    if (locationContainer) {
      locationContainer.querySelector('dl').remove();

      const icon = document.createElement('i');
      icon.classList.add('mec-sl-info');
      locationContainer.prepend(icon);

      const extendedLocation = document.querySelector('.mec-single-event-location__extended');
      locationContainer.appendChild(extendedLocation);
    }

    // Remove default alt locations and repopulate with the extended version
    const altLocations = document.querySelector('.mec-single-event-additional-locations');
    if (altLocations) {
      altLocations.remove();
    }

    // Move share to the bottom
    const shareContainer = document.querySelector('.mec-event-social');
    if (shareContainer) {
      shareContainer.parentElement.appendChild(shareContainer);
    }

    // Remove rescheduled and canceled formats
    const formatLabel = document.querySelector('.mec-single-event-label');
    if (formatLabel) {
      const formats = formatLabel.querySelectorAll('dd');
      if (formats) {
        const sideNav = formatLabel.parentElement;
        sideNav.appendChild(formatLabel);

        formats.forEach(format => {
          if (format.innerHTML.indexOf('Rescheduled') > -1) {
            format.remove();
          } else if (format.innerHTML.indexOf('Cancelled') > -1) {
            format.remove();
            document.querySelector(`.mec-events-meta-group-booking`).remove();
            document.querySelector(`.simple-booking`).remove();

            const cancelledButton = document.createElement('div');
            cancelledButton.classList.add('mec-booking-button', 'cancelled-booking');
            cancelledButton.innerHTML = 'Cancelled';
            sideNav.appendChild(cancelledButton);
          }
        });
      }
      if (formatLabel.querySelectorAll('dd').length === 0) {
        formatLabel.remove();
      }
    }

    // Booking error message
    this.msg = document.querySelector(`#mec_booking_message${this.eventId}`);
    if (this.msg) {
      this.onClassChange(this.msg, node => {
        if (node.classList.contains('mec-error')) {
          this.msg.style.removeProperty('display');
          if (this.msg.innerHTML.includes('You should book')) {
            this.msg.innerHTML = 'Please book at least one ticket.';
          } else if (this.msg.innerHTML.includes('Email')) {
            this.msg.innerHTML = 'Please provide an accurate email address.';
          }
        }
      });
    }

    // Only add this if there are multiple instances
    let oneDate = true;
    if (document.querySelector('.mec-event-tickets-list')) {
      oneDate = false;
    }

    this.datesDropdownRemoved(oneDate);
    this.setupTicketSelectView();

    // Adjust the Successfully Canceled message
    const success = document.querySelector('.mec-success');
    if (success) {
      success.innerHTML = 'Your registration has been canceled.';
    }

    // Setup location slider
    const map = document.querySelector('.mec-single-locations');
    if (map) {
      const mapContainer = document.querySelector('.mec-events-meta-group-gmap');
      const mapDetails = mapContainer.querySelector('.mec-googlemap-details');
      if (mapDetails) {
        mapDetails.remove();
      }

      mapContainer.appendChild(map);
    }

    const locations = document.querySelectorAll('.mec-single-locations .mec-location-slide');
    const pagers = document.querySelectorAll('.location-pager');

    if (locations.length > 1) {
      this.currentLocation = 0;
      this.maxLocations = locations.length - 1;

      // Switch which is the active location
      pagers.forEach(pager => {
        pager.addEventListener('click', event => {
          const target = event.target;
          if (target.dataset.controls === 'prev') {
            this.currentLocation = this.currentLocation - 1 > -1 ? this.currentLocation - 1 : this.maxLocations;
          } else if (target.dataset.controls === 'next') {
            this.currentLocation = this.currentLocation + 1 <= this.maxLocations ? this.currentLocation + 1 : 0;
          }

          locations.forEach(location => {
            if (parseInt(location.dataset.number) === this.currentLocation) {
              location.classList.remove('hidden');
            } else {
              location.classList.add('hidden');
            }
          });
        });
      });
    } else {
      pagers.forEach(pager => {
        pager.classList.add('hidden');
      });
    }
  }

  setupTicketSelectView() {
    let currentDate;

    if (this.eventId) {
      const currentDateElement = document.querySelector('.mec-select-date-dropdown .mec-custom-nice-select');
      if (currentDateElement) { // multiple dates
        currentDate = currentDateElement.value;

        // Convert date strings
        if (!this.timeConverted) {
          this.timeConverted = true;
          const options = currentDateElement.querySelectorAll('option');
          options.forEach(option => {
            const trimValue = option.innerHTML.trim();

            const deliminator = trimValue.indexOf(' - ');
            let date;
            let day;
            let month;

            if (deliminator > -1) {
              const first = trimValue.substring(0, deliminator);
              const second = trimValue.substring(deliminator + 3);

              const firstDate = first.substring(0, 10);
              const firstTime = first.substring(11);
              const secondTime = second.substring(11);

              date = new Date(firstDate);
              month = date.toLocaleString('default', { month: 'long' });
              day = parseInt(firstDate.substring(8));

              // TODO: Check if the dates are different
              option.innerHTML = `${month} ${day}, ${firstTime} - ${secondTime}`;
            } else {
              date = new Date(trimValue);
              month = date.toLocaleString('default', { month: 'long' });
              day = parseInt(trimValue.substring(8));

              const time = document.querySelector('.mec-single-event-time .mec-events-abbr').innerHTML;
              option.innerHTML = `${month} ${day}, ${time}`;
            }
          });
        }

        this.determineIfWaitlist(currentDate);
      } else { // Only one date
        const soldOutBlock = document.querySelector('.mec-sold-tickets');
        if (soldOutBlock) { // Only one ticket
          soldOutBlock.firstChild.remove();
        }

        const dateElement = document.querySelector('[data-date]');
        if (dateElement) {
          const date = dateElement.dataset.date;
          this.determineIfWaitlist(date, true);
        } else {
          this.determineIfWaitlist(null, true);
        }
      }
    }
  }

  // Overwrite the functionality if there is a waitlisted ticket
  determineIfWaitlist(currentDate, oneDate = false) {
    // Update the class list for the error message
    if (this.msg) {
      this.msg.classList.remove('mec-error');
      this.msg.classList.add('mec-util-hidden');
    }

    let formDOM;
    let waitListSection;
    let oneTicket = true;
    let ticketsWaitlisted = 0;
    let ticketsEnded = 0;

    const tickets = document.querySelectorAll('.mec-event-ticket');
    const soldOutBlock = document.querySelector('.mec-sold-tickets');

    if (oneDate) { // One date
      if (!tickets.length > 0) {
        if (soldOutBlock) {

          const ticketRow = document.querySelector('.mec-ticket-available-spots.mec-ticket-style-row');
          if (ticketRow) {
            ticketRow.querySelector('.mec-ticket-style-row-section-3').style.display = 'block';
          }

          const ticketDesc = document.querySelector('.mec-event-ticket-description');
          if (ticketDesc) {
            ticketDesc.style.display = 'block';
          }

          const booking = document.querySelector('.mec-booking');
          if (booking) {
            formDOM = booking.querySelector('form');

            if (ticketRow) {
              ticketRow.querySelector('.mec-ticket-style-row-section-3').style.display = 'none';
            }
            if (ticketDesc) {
              ticketDesc.style.display = 'none';
            }

            ticketsWaitlisted ++;
            this.fillWaitlistForm(null, currentDate, formDOM, null, true, oneTicket, oneDate);// true
          }
        } else {
          const ticketsUnavailable = document.querySelectorAll('.mec-ticket-unavailable-spots');

          if (ticketsUnavailable.length > 0) {
            ticketsUnavailable.forEach((ticketUnavailable, key) => {
              if (key === 0) {
                ticketsEnded ++;
                ticketUnavailable.innerHTML = `<div class="reg-ended">Registration for this date has ended.</div>`;
              } else {
                ticketUnavailable.remove(0);
              }
            });
          }
        }
      } else {
        oneTicket = false;
        tickets.forEach(ticket => {
          const ticketRow = ticket.querySelector('.mec-ticket-available-spots.mec-ticket-style-row');
          if (ticketRow) {
            ticketRow.querySelector('.mec-ticket-style-row-section-3').style.display = 'block';
          }
          const ticketDesc = ticket.querySelector('.mec-event-ticket-description');
          if (ticketDesc) {
            ticketDesc.style.display = 'block';
          }

          const ticketInput = ticket.querySelector('.mec-ticket-available-spots .mec-event-ticket-input-wrapper').parentElement;
          formDOM = ticket.querySelector('.mec-ticket-unavailable-spots');

          if (formDOM.classList.contains('mec-util-hidden')) {
            ticketInput.style.display = 'block';
          } else {
            if (ticketRow) {
              ticketRow.querySelector('.mec-ticket-style-row-section-3').style.display = 'none';
            }
            if (ticketDesc) {
              ticketDesc.style.display = 'none';
            }

            waitListSection = formDOM.querySelector('[data-ticket-id]');

            if (formDOM.classList.contains('info-msg')) {
              ticketsWaitlisted ++;
              this.fillWaitlistForm(ticket, currentDate, formDOM, ticketInput, false, oneTicket, oneDate);// true
            } else if (waitListSection) {
              if (!formDOM.classList.contains('mec-error')) {
                ticketsWaitlisted ++;
                this.fillWaitlistForm(ticket, currentDate, formDOM, ticketInput, false, oneTicket, oneDate);// true
              } else {
                ticketsEnded ++;
                formDOM.innerHTML = `<div class="reg-ended">Registration for this date has ended.</div>`;
              }
            } else {
              ticketsEnded ++;
              formDOM.innerHTML =  `<div class="reg-ended">Registration for this date has ended.</div>`;
            }
          }
        });
      }
    } else { // Multiple dates
      if (tickets.length === 1) {
        const ticket = tickets[0];
        const ticketRow = ticket.querySelector('.mec-ticket-available-spots.mec-ticket-style-row');
        if (ticketRow) {
          ticketRow.querySelector('.mec-ticket-style-row-section-3').style.display = 'block';
        }
        const ticketDesc = ticket.querySelector('.mec-event-ticket-description');
        if (ticketDesc) {
          ticketDesc.style.display = 'block';
        }

        const ticketsUnavailable = document.querySelector('.mec-ticket-unavailable-spots');
        if (!ticketsUnavailable.classList.contains('mec-util-hidden')) {
          if (ticketRow) {
            ticketRow.querySelector('.mec-ticket-style-row-section-3').style.display = 'none';
          }
          if (ticketDesc) {
            ticketDesc.style.display = 'none';
          }

          if (!ticketsUnavailable.classList.contains('mec-error')) {
            ticketsWaitlisted ++;
            this.fillWaitlistForm(ticket, currentDate, ticketsUnavailable, null, true, oneTicket, oneDate);
          } else {
            ticketsEnded ++;
            ticketsUnavailable.innerHTML = `<div class="reg-ended">Registration for this date has ended.</div>`;
          }


        }
      } else {
        oneTicket = false;
        tickets.forEach(ticket => {
          const ticketRow = ticket.querySelector('.mec-ticket-available-spots.mec-ticket-style-row');
          if (ticketRow) {
            ticketRow.querySelector('.mec-ticket-style-row-section-3').style.display = 'block';
          }
          const ticketDesc = ticket.querySelector('.mec-event-ticket-description');
          if (ticketDesc) {
            ticketDesc.style.display = 'block';
          }

          const ticketInput = ticket.querySelector('.mec-ticket-available-spots .mec-event-ticket-input-wrapper').parentElement;
          formDOM = ticket.querySelector('.mec-ticket-unavailable-spots');

          if (formDOM.classList.contains('mec-util-hidden')) {
            ticketInput.style.display = 'block';
          } else {
            if (ticketRow) {
              ticketRow.querySelector('.mec-ticket-style-row-section-3').style.display = 'none';
            }
            if (ticketDesc) {
              ticketDesc.style.display = 'none';
            }

            waitListSection = formDOM.querySelector('[data-ticket-id]');

            if (formDOM.classList.contains('info-msg')) {
              ticketsWaitlisted ++;
              this.fillWaitlistForm(ticket, currentDate, formDOM, ticketInput, false, oneTicket, oneDate);
            } else if (waitListSection) {
              if (!formDOM.classList.contains('mec-error')) {
                ticketsWaitlisted ++;
                this.fillWaitlistForm(ticket, currentDate, formDOM, ticketInput, false, oneTicket, oneDate);
              } else {
                ticketsEnded ++;
                formDOM.innerHTML = `<div class="reg-ended">Registration for this date has ended.</div>`;
              }
            } else {
              ticketsEnded ++;
              formDOM.innerHTML =  `<div class="reg-ended">Registration for this date has ended.</div>`;
            }
          }
        });
      }
    }

    const nextButton = document.querySelector('.mec-book-form-btn-wrap');
    if (nextButton) {
      if (tickets.length === ticketsWaitlisted + ticketsEnded) {
        nextButton.style.display = 'none';
      } else {
        nextButton.style.display = 'block';
      }
    }

    const header = document.querySelector('.mec-booking h4');
    if (header) {
      if (tickets.length === ticketsWaitlisted || (oneTicket && oneDate)) {
        header.innerHTML = 'Waiting List';
      } else if (tickets.length === ticketsEnded) {
        header.innerHTML = 'Registration Ended';
      } else {
        header.innerHTML = 'Book Event';
      }
    }

    // Unhide the ticket type
    const ticketTypes = document.querySelectorAll('.mec-ticket-available-spots.mec-util-hidden');
    ticketTypes.forEach(ticketType => {
      ticketType.classList.remove('mec-util-hidden');
    });
  }

  // Populate the form, based on how many days, tickets, and original view
  fillWaitlistForm(ticket, currentDate, formDOM, ticketInput = null, addWaitingDate = false, oneTicket = false, oneDate = false) {
    let innerHTML;
    let id;
    let unavailableSpots;

    const soldOutText = 'This program is sold out. You can register for the waitlist below.';

    if (ticketInput) {
      ticketInput.style.display = 'none';
    }

    if (oneTicket && oneDate) {
      const ticketIdElement = document.querySelector('[data-ticket-id]');
      id = ticketIdElement.dataset.ticketId;

      formDOM.innerHTML = `
      <h4>Waiting List</h4>

      <input type="hidden" name="book[date]" id="mec_book_form_date1" value="${currentDate}">
      `;

      unavailableSpots = document.createElement('div');
      unavailableSpots.classList.add('mec-ticket-unavailable-spots', 'info-msg');
    } else {
      id = formDOM.id.substring(19);
    }

    innerHTML = `
    <div>
      <b>${soldOutText}</b>
    </div>
    <br>
    <div id="mec_waiting_reg_field_count_area_${this.eventId}_${id}" data-ticket-id="${id}">
    <div class="mec_waiting_reg_field_count_area_labels">
    <label for="mec_waiting_reg_field_count_${this.eventId}_${id}">You can only register one person at a time for the waitist.</label>
    </div>
    <input type="number" id="mec_waiting_reg_field_count_${this.eventId}_${id}" class="mec-waiting-list-ticket-limit" name="waiting[count][${id}]" title="Count" placeholder="Count" value="1" min="1" max="" data-seats="1" style="display: none;">
    </div>
    `;

    if (addWaitingDate) {
      innerHTML += `<div class="display:none" id="waiting-data-date-${this.eventId}_${id}" data-date="${currentDate}"></div>`;
    }

    if (oneTicket && oneDate) {
      unavailableSpots.innerHTML = innerHTML;
      formDOM.appendChild(unavailableSpots);
    } else {
      formDOM.innerHTML = innerHTML;
    }

    const divCont = document.createElement('div');
    divCont.classList.add('mec-waiting-form-btn-wrap');

    const registrationButton = document.createElement('button');
    registrationButton.id = `waiting_register_btn_${this.eventId}_${id}`;

    /* eslint-disable */
    registrationButton.onclick = () => { waiting_register(`${this.eventId}_${id}`, this.eventId, id); };
    /* eslint-enable */

    registrationButton.innerHTML = 'Register for Waitlist';

    const div = document.createElement('div');
    div.classList.add('mec-waiting-form-container', 'row');
    div.id = `mec_waiting_form_content_${this.eventId}_${id}`;
    const p = document.createElement('p');
    p.id = `mec_waiting_message${this.eventId}_${id}`;
    const input1 = document.createElement('input');
    input1.type = 'hidden';
    const input2 = document.createElement('input');
    input2.type = 'hidden';

    if (oneTicket && oneDate) {
      input1.name = `event_id`;
      input1.value = `${this.eventId}`;
      input2.name = `uniqueid`;
      input2.value = `${id}`;

      divCont.appendChild(registrationButton);
      unavailableSpots.appendChild(divCont);
      unavailableSpots.appendChild(div);
      unavailableSpots.appendChild(input1);
      unavailableSpots.appendChild(input2);
    } else {
      input1.id = `mec-ticket-message-sales-${id}`;
      input1.value = ``;
      input2.id = `mec-ticket-message-sold-out-${id}`;
      input2.value = ``;

      divCont.appendChild(registrationButton);
      formDOM.appendChild(divCont);
      formDOM.appendChild(div);
      formDOM.appendChild(input1);
      formDOM.appendChild(input2);
    }

    this.waitForSubmit(div);
  }

  addTicketListMutationListener() {
    this.addListener = false;
    this.ticketList = document.querySelector('.mec-event-tickets-list');

    this.onClassChange(this.ticketList, node => {
      if (!node.classList.contains('loading')) {
        this.setupTicketSelectView();
      }
    });
  }

  // Helper mutation observer for class changes
  onClassChange(element, callback) {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          callback(mutation.target);
        }
      });
    });

    observer.observe(element, { attributes: true });
    return observer.disconnect;
  }

  // Wait for waitlist Submit button to appear so we can hook into it for waitlist confirmations
  waitForSubmit(element) {
    const observer = new MutationObserver(() => {
      const submitButton = document.querySelector('.mec-waiting-form-submit-button');

      if (element.contains(submitButton)) {
        this.onClassChange(submitButton, node => {
          if (!node.classList.contains('loading')) {
            this.waitlistConfirmed(element);
          }
        });
      }
    });

    observer.observe(element, { childList: true, attributes: true });
    return observer.observe;
  }

  // Helper function to tell if an element is added to the list view
  onElementAddedToForm() {
    if (this.msg && this.msg.style.display) {
      this.msg.style.removeProperty('display');
    }
    const booking = document.querySelector('.mec-booking');

    if (booking) {
      const observer = new MutationObserver(() => {
        this.catchSubmitButton();
        this.moveFormOrder();
        this.registrationSubmit();
      });

      observer.observe(booking, { childList: true, attributes: true });
      return observer.disconnect;
    }
  }

  registrationSubmit() {
    const message = document.querySelector('.mec-event-book-message');

    if (message && message.innerHTML.toLowerCase().indexOf('thank you') > 0) {
      /* eslint-disable */
      dataLayer.push(this.analytics);
      /* eslint-enable */
    }
  }

  moveFormOrder() {
    const tickets = document.querySelector('.mec-book-tickets-container');

    if (tickets) {
      const customFields = document.querySelector('.mec-book-bfixed-fields-container');
      tickets.after(customFields);
    }
  }

  // Catch the submit button
  catchSubmitButton() {
    const submitButton = document.querySelector('button.mec-book-form-next-button[type="submit"]');
    if (submitButton && submitButton.innerHTML.toLowerCase().indexOf('submit') > 0) {
      submitButton.addEventListener('click', () => this.submitClicked());
    }
  }

  submitClicked() {
    const tickets = document.querySelectorAll('h4.event-registration-data');

    tickets.forEach(ticket => {
      this.analytics.tickets[ticket.dataset.name] = ticket.dataset.count;
    });

    const inputs = document.querySelectorAll('.mec-book-tickets-reg-fields-container li input:checked');
    const dateSelect = document.querySelector('.mec-select-date-dropdown select');

    if (dateSelect) {
      const date = dateSelect.querySelector(`option[value="${dateSelect.value}"]`).innerHTML;

      this.analytics.date = date.substring(0, date.indexOf(':'));
    } else {
      const date = document.querySelector('.mec-single-event-date .mec-start-date-label').innerHTML;
      const time = document.querySelector('.mec-single-event-time .mec-events-abbr').innerHTML;

      this.analytics.date = `${date} ${time}`;
    }

    if (inputs) {
      inputs.forEach(input => {
        const parent = input.closest('li');
        const question = parent.querySelector('label:first-of-type');
        if (question.innerHTML.toLowerCase().indexOf('member') > 0) {
          if (input.value.toLowerCase().indexOf('yes') > 0) {
            this.analytics.member = 'true';
          } else {
            this.analytics.member = 'false';
          }
        } else if (question.innerHTML.toLowerCase().indexOf('hear') > 0) {
          this.analytics.source = input.value;
        }
      });
    }
  }

  // Readd the mutation observer when leaving the booking confirmation view
  datesDropdownRemoved(oneDate) {
    const booking = document.querySelector('.mec-booking');

    if (booking) {
      const observer = new MutationObserver(() => {
        const ticketList = document.querySelector('.mec-event-tickets-list');
        if (!document.contains(ticketList) || (oneDate && this.addListener === false)) {
          this.addListener = true;
          this.calculateTickets();
        } else {
          if (this.addListener) {
            this.addTicketListMutationListener();
          }
        }
      });

      if (!oneDate) {
        this.addTicketListMutationListener();
      }

      observer.observe(booking, { childList: true, attributes: true });
      return observer.disconnect;
    }
  }

  // Store all the tickets registered and inject them into the attendee's form
  calculateTickets() {
    const tickets = document.querySelectorAll('.mec-book-ticket-container');
    const bookings = [];

    tickets.forEach(ticket => {
      const id = bookings.length;
      const ticketId = ticket.querySelector('input[name*="[id]"]').value;

      const booking = bookings.filter(value => value.ticketId === ticketId);
      if (booking.length) {
        const bookingId = booking[0].id;
        bookings[bookingId].count ++;
      } else {
        const ticketNameElement = ticket.querySelector('.mec-ticket-name');
        if (ticketNameElement) {
          const ticketName = ticketNameElement.innerHTML;
          bookings.push({ id: id, ticketId: ticketId, name: ticketName, count: 1 });
        }
      }
    });

    const wrapper = document.querySelectorAll('.mec-book-ticket-container .mec-ticket-name-description-wrapper');
    if (wrapper.length) {
      let innerHTML = '';

      bookings.forEach(booking => {
        innerHTML += `<h4 class="event-registration-data" data-name="${booking.name}" data-count="${booking.count}">${booking.name} x ${booking.count}</h4>`;
      });

      wrapper[0].innerHTML = innerHTML;
    }
  }

  // Change the confirmation text for waitlist registration
  waitlistConfirmed(element) {
    if (!element.querySelector('.mec-waiting-ticket-container')) {
      const container = element.closest('.mec-ticket-unavailable-spots');

      if (container) { // if the receipt view
        container.innerHTML = 'Thank you for registering for the waitlist.<br><br>You will receive an email confirmation for the waitlist in the next few minutes, with "Waitlist Confirmation" in the subject line. If you later receive an email with "Registration Confirmed" in the subject line, that means you are off the waitlist and have been registered for the program.';
      }
    }
  }
}

export default MECSingleEvent;
